import { filterTypeDictionary as filterType, tabHeadingDictionary as tabKeywords } from "@core/global/global-country-dictionary";
import { getInternationalNumberSystem } from "@core/utility/utility";
import UpgradeIconSmall from "@assets/images/zap-icon.svg";
import { displayCount } from "@utils/utils";
import AnalyticsIcon from "@assets/images/icons/analytics.svg";
import { Card } from "react-bootstrap";
import Shipment from "./Shipment/Shipment";
import Importer from "./Importer/Importer";
import Analytics from "./Analytics/Analytics";
import Report from "./Report/Report";
import Exporter from "./Exporter/Exporter";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import SaveSearch from "./components/SaveSearch";
import Logistics from "./Logistics";
import { useSelector } from "react-redux";

const RightPanel = (props) => {
  const showTabDataHandler = () => {
    switch (props.currentTab) {
      case tabKeywords.exporters:
        return <Exporter {...props} />;
      case tabKeywords.importers:
        return <Importer {...props} />;
      case tabKeywords.analytics:
        return <Analytics {...props} />;
      case tabKeywords.shipments:
        return <Shipment {...props} />;
      case tabKeywords.reports:
        return <Report {...props} />;
      case tabKeywords.logistics:
        return <Logistics {...props} />;
    }
  };

  const userDetails = useSelector((state) => state.userDetails);

  return (
    <div>
      {props.isParentCompany ? (
        <div className="tw-py-2 d-flex align-items-center parent-info-text">
          <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1686824367/intel/icons/info_qehecc.svg" />
          <span className="ml-2">
            The search results also contain shipments for subsidiaries of{" "}
            <span className="text-capitalize">
              <strong>{props.parentCompanyNames.join(", ")}</strong>
            </span>
          </span>
        </div>
      ) : (
        <></>
      )}
      {props.totalSearchCount === 0 ? (
        <Card>
          <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-5 tw-h-[36rem]">
            <div className="text-center">
              <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1670225921/intel/icons/no_result_illustration_avz4aw.svg" className="mx-auto d-block" alt="No Data Found" />
            </div>
            {(props?.zeroCountDataObj?.all_category_count?.count || props?.zeroCountDataObj?.all_data_source_count?.count || (!!props.zeroCountData && props.zeroCountData !== 0 && props.zeroCountData !== "") || (!!props.zeroFilterData && props.zeroFilterData !== 0 && props.zeroFilterData !== "")) && !props.isZeroDataSource ? (
              <>
                {props.zeroCountUpgrade === true ? (
                  <div className="tw-flex tw-gap-2 tw-flex-col tw-items-center tw-justify-center tw-text-center">
                    <div className="tw-font-medium tw-text-lg">
                      <span className="mr-2">
                        <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                      </span>
                      <span>{props.zeroCountData}</span>
                      <span>{props.zeroCountData > 1 ? " shipments" : " shipment"}</span>
                      <span> found for your search query in Last </span>
                      <span>{new Date().getFullYear() - props.zeroCountyear > 0 ? new Date().getFullYear() - props.zeroCountyear : ""}</span>
                      <span>{new Date().getFullYear() - props.zeroCountyear > 0 ? " years" : " year"}</span>
                    </div>
                    <div>
                      <button className="btn btn-primary tw-bg-secondary-green tw-border-secondary-green tw-text-white" onClick={(e) => props.callNavigationToPlans(e)}>
                        Upgrade to get more data access
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="zero-search-text tw-flex tw-gap-5 tw-flex-col tw-items-center tw-justify-center tw-text-center mt-3">
                    Expand your search by:
                    <div className="tw-flex tw-gap-3 tw-flex-col tw-items-center tw-justify-center tw-text-center">
                      {props?.zeroCountDataObj?.count_without_filter?.count > 0 && props?.zeroCountDataObj?.count_without_filter?.count !== props.zeroCountData ? (
                        <button
                          onClick={() => {
                            props.checkPendoEventForCompanyRedirection?.(trackingEventDictionary.alternateSuggestionZeroSearch);
                            props.resetFilter("zeroSearch");
                          }}
                          className="btn btn-primary trademo-new-btn zero-button text-white tw-w-max">
                          Removing the applied filters - {getInternationalNumberSystem(props.zeroFilterData)} shipments
                        </button>
                      ) : null}
                      {props.zeroCountData > 0 && props.zeroCountData !== "" ? (
                        <button
                          onClick={() => {
                            props.checkPendoEventForCompanyRedirection?.(trackingEventDictionary.alternateSuggestionZeroSearch);
                            props.handleZeroDataSearch(props.zeroCountDateRange, "zeroSearch");
                          }}
                          className="btn btn-primary trademo-new-btn zero-button text-white tw-w-max">
                          {props.zeroCaseHandler()}
                        </button>
                      ) : null}
                      {props?.zeroCountDataObj?.all_category_count?.count > 0 ? (
                        <button
                          onClick={() => {
                            props.checkPendoEventForCompanyRedirection?.(trackingEventDictionary.alternateSuggestionZeroSearch);
                            props?.handleGoToAllCategory();
                          }}
                          className="btn btn-primary trademo-new-btn zero-button text-white tw-w-max">
                          Searching across All Categories in {props?.defaultData?.name || "Current Dataset"} - {getInternationalNumberSystem(props.zeroCountDataObj.all_category_count.count)} shipments
                        </button>
                      ) : null}
                      {props?.zeroCountDataObj?.all_data_source_count?.count > 0 ? (
                        <button
                          onClick={() => {
                            props.checkPendoEventForCompanyRedirection?.(trackingEventDictionary.alternateSuggestionZeroSearch);
                            props?.handleGoToAllDatasets();
                          }}
                          className="btn btn-primary trademo-new-btn zero-button text-white tw-w-max">
                          Searching across All Subscribed Datasets - {getInternationalNumberSystem(props.zeroCountDataObj.all_data_source_count.count)} shipments
                        </button>
                      ) : null}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                {props.zeroCountData === 0 || props.isZeroDataSource ? (
                  <div className="tw-flex tw-gap-2 tw-flex-col tw-items-center tw-justify-center tw-text-center">
                    <p>No results found for your search criteria.</p>
                    <button onClick={() => props.goBackRedirectUser()} className="btn btn-primary trademo-new-btn zero-button text-white">
                      Go back to all data
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
          </div>
        </Card>
      ) : (
        <div className="trademo-tab-panel">
          <div className="d-flex justify-content-between tw-items-end">
            <nav className="tw-flex tw-justify-between tw-w-max px-0 tabs-style">
              <div className="nav nav-tabs search-tabs d-flex w-100 tw-px-4" id="nav-tab" role="tablist">
                {!!props.currentPlanAccess && props.currentPlanAccess.shipments === false ? (
                  <a
                    className={props.currentTab === tabKeywords.shipments ? "nav-item nav-link active bg-transparent" : "nav-item nav-link"}
                    id="nav-home-tab"
                    data-toggle="tab"
                    href="#nav-home"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected={props.currentTab === tabKeywords.shipments}
                    onClick={() => {
                      props.setCurrentTabHandler(tabKeywords.shipments);
                      props.checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentTab);
                    }}>
                    Shipments
                    <span className="ml-1">
                      <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                    </span>
                  </a>
                ) : (
                  <a className={props.currentTab === tabKeywords.shipments ? "nav-item nav-link active bg-transparent" : "nav-item nav-link"} id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected={props.currentTab === tabKeywords.shipments} onClick={props.displayShipmentTab}>
                    Shipments <span className={` tw-text-xs tw-p-1 tw-rounded ${props.currentTab === tabKeywords.shipments ? "tw-bg-primary-purple-100 tw-text-primary-purple-600 tw-font-medium" : "tw-bg-gray-300 tw-text-gray-900 tw-font-normal"}`}>{displayCount(props.totalCustomShipments, 2)}</span>
                  </a>
                )}
                {props.defaultData && props.defaultData.tabKeyWords && props.defaultData.tabKeyWords.importers ? (
                  !!props.currentPlanAccess && props.currentPlanAccess.consignee_shipper === false ? (
                    <a
                      className={!!props.currentTab && props.currentTab === tabKeywords.importers ? "nav-item nav-link active bg-transparent" : "nav-item nav-link"}
                      id="nav-profile-tab"
                      data-toggle="tab"
                      href="#nav-profile"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                      onClick={() => {
                        props.setCurrentTabHandler(tabKeywords.importers);
                        props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImporterTab);
                      }}>
                      Importers
                      <span className="ml-1">
                        <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                      </span>
                    </a>
                  ) : (
                    <a
                      className={!!props.currentTab && props.currentTab === tabKeywords.importers ? "nav-item nav-link active bg-transparent" : "nav-item nav-link"}
                      id="nav-profile-tab"
                      data-toggle="tab"
                      href="#nav-profile"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                      onClick={() => {
                        props.onTabChangeHandler(tabKeywords.importers);
                        props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImporterTab);
                      }}>
                      Importers <span className={` tw-text-xs tw-p-1 tw-rounded ${props.currentTab === tabKeywords.importers ? "tw-bg-primary-purple-100 tw-text-primary-purple-600 tw-font-medium" : "tw-bg-gray-300 tw-text-gray-900 tw-font-normal"}`}>{displayCount(props.totalUniqueImporter, 2)}</span>
                    </a>
                  )
                ) : (
                  <></>
                )}
                {props.defaultData && props.defaultData.tabKeyWords && props.defaultData.tabKeyWords.exporters ? (
                  !!props.currentUserPlan && props.currentUserPlan !== "" && !!props.currentPlanAccess && props.currentPlanAccess.consignee_shipper === false ? (
                    <a
                      className={props.currentTab === tabKeywords.exporters ? "nav-item nav-link active bg-transparent" : "nav-item nav-link"}
                      id="nav-contact-tab"
                      data-toggle="tab"
                      href="#nav-contact"
                      role="tab"
                      aria-controls="nav-contact"
                      aria-selected="false"
                      onClick={() => {
                        props.setCurrentTabHandler(tabKeywords.exporters);
                        props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExporterTab);
                      }}>
                      Exporters
                      <span className="ml-1">
                        <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                      </span>
                    </a>
                  ) : (
                    <a
                      className={props.currentTab === tabKeywords.exporters ? "nav-item nav-link active bg-transparent" : "nav-item nav-link"}
                      id="nav-contact-tab"
                      data-toggle="tab"
                      href="#nav-contact"
                      role="tab"
                      aria-controls="nav-contact"
                      aria-selected="false"
                      onClick={() => {
                        props.onTabChangeHandler(tabKeywords.exporters);
                        props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExporterTab);
                      }}>
                      Exporters <span className={` tw-text-xs tw-p-1 tw-rounded ${props.currentTab === tabKeywords.exporters ? "tw-bg-primary-purple-100 tw-text-primary-purple-600 tw-font-medium" : "tw-bg-gray-300 tw-text-gray-900 tw-font-normal"}`}>{displayCount(props.totalUniqueExporter, 2)}</span>
                    </a>
                  )
                ) : (
                  <></>
                )}
                {props.defaultData && props.defaultData.tabKeyWords && props.defaultData.tabKeyWords.logistics && userDetails.creditDetails?.planAccess?.is_logistic_profile ? (
                  !!props.currentUserPlan && props.currentUserPlan !== "" && !!props.currentPlanAccess && props.currentPlanAccess.consignee_shipper === false ? (
                    <a
                      className={props.currentTab === tabKeywords.logistics ? "nav-item nav-link active bg-transparent" : "nav-item nav-link"}
                      id="nav-contact-tab"
                      data-toggle="tab"
                      href="#nav-contact"
                      role="tab"
                      aria-controls="nav-contact"
                      aria-selected="false"
                      onClick={() => {
                        props.setCurrentTabHandler(tabKeywords.logistics);
                        props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTab);
                      }}>
                      Logistics
                      <span className="ml-1">
                        <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                      </span>
                    </a>
                  ) : (
                    <a
                      className={props.currentTab === tabKeywords.logistics ? "nav-item nav-link active bg-transparent" : "nav-item nav-link"}
                      id="nav-contact-tab"
                      data-toggle="tab"
                      href="#nav-contact"
                      role="tab"
                      aria-controls="nav-contact"
                      aria-selected="false"
                      onClick={() => {
                        props.onTabChangeHandler(tabKeywords.logistics);
                        props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTab);
                      }}>
                      Logistics <span className={` tw-text-xs tw-p-1 tw-rounded ${props.currentTab === tabKeywords.logistics ? "tw-bg-primary-purple-100 tw-text-primary-purple-600 tw-font-medium" : "tw-bg-gray-300 tw-text-gray-900 tw-font-normal"}`}>{displayCount(props.totalUniqueLogistics, 2)}</span>
                    </a>
                  )
                ) : (
                  <></>
                )}
                {props.defaultData && props.defaultData.tabKeyWords && props.defaultData.tabKeyWords.analytics ? (
                  !!props.currentPlanAccess && props.currentPlanAccess.is_analytics_tab === false ? (
                    <a
                      className={props.currentTab === tabKeywords.analytics ? "nav-item nav-link active bg-transparent" : "nav-item nav-link"}
                      id="nav-summary-tab"
                      data-toggle="tab"
                      href="#nav-summary"
                      role="tab"
                      aria-controls="nav-summary"
                      aria-selected={props.currentTab === tabKeywords.analytics}
                      onClick={() => {
                        props.setCurrentTabHandler(tabKeywords.analytics);
                        props.checkPendoEventForCompanyRedirection(trackingEventDictionary.analyticsTab);
                      }}>
                      Analytics
                      <span className="ml-1">
                        <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                      </span>
                    </a>
                  ) : (
                    <a
                      className={props.currentTab === tabKeywords.analytics ? "nav-item nav-link active bg-transparent" : "nav-item nav-link"}
                      id="nav-summary-tab"
                      data-toggle="tab"
                      href="#nav-summary"
                      role="tab"
                      aria-controls="nav-summary"
                      aria-selected={props.currentTab === tabKeywords.analytics}
                      onClick={() => {
                        props.onTabChangeHandler(tabKeywords.analytics);
                        props.checkPendoEventForCompanyRedirection(trackingEventDictionary.analyticsTab);
                      }}>
                      Analytics
                    </a>
                  )
                ) : (
                  <></>
                )}
                {props.defaultData && props.defaultData.tabKeyWords && props.defaultData.tabKeyWords.reports ? (
                  !!props.currentPlanAccess && props.currentPlanAccess.is_analytics_tab === false ? null : (
                    <a className={props.currentTab === tabKeywords.reports ? "nav-item nav-link active bg-transparent" : "nav-item nav-link"} id="nav-summary-tab" data-toggle="tab" href="#nav-summary" role="tab" aria-controls="nav-summary" aria-selected={props.currentTab === tabKeywords.reports} onClick={props.reportTabClick}>
                      Reports
                      <img src={AnalyticsIcon} alt="..." className="img-fluid mx-2" />
                    </a>
                  )
                ) : (
                  <></>
                )}
              </div>
            </nav>
            <span className="ml-auto px-2 py-1 my-auto mob-btns">
              {(!!props.appliedStateFilterObject && props.checkforFilters(props.appliedStateFilterObject)) || (!!props.searchedItem && props.searchedItem !== "") ? (
                <SaveSearch
                  currentUserPlan={props.currentUserPlan}
                  analyticsCountryID={props.defaultData.analyticsCountryID}
                  isisBooleanFilter={props.defaultData.isBooleanFilter}
                  appliedBooleanFilterObject={props.appliedBooleanFilterObject}
                  appliedState={props.appliedStateFilterObject}
                  isFilterApplied={props.isFilterApplied}
                  queryType={props.searchQueryType}
                  searchKey={props.searchKey}
                  currentPlanAccess={props.currentPlanAccess}
                  searchString={props.searchedItem}
                  savedSearchRequestObject={props.finalReqObj}
                  searchType={props.searchTypeStr}
                  filterList={props.filterMapList}
                  currentTab={props.currentTab}
                  isLoaderActive={props.isLoaderActive}
                  country={props.defaultData.countryCaps}
                  tradeDirection={props.defaultData.manyCountryType.toUpperCase()}
                  productId={props.defaultData.product_id}
                  redirectionId={props.defaultData.redirectionID}
                  selectedFilterList={props.selectedFilterLabelObject}
                  booleanFilterList={props.defaultBooleanFilterObject}
                  appliedBooleanFilterList={props.appliedBooleanFilterObject}
                  filterType={filterType}
                  isChemicalPresent={props.isChemicalPresent}
                  handleNudgePopup={(key) => props.handleNudgePopup(key, "event")}
                  savedSearchShow={props.savedSearchShow}
                  closeSaveSearch={() => props.setSavedSearchShow(false)}
                  clearNudgePopupTimer={() => props.setShowNudgePopup(false)}
                  includeFilter={props.includeFilter}
                  excludeFilter={props.excludeFilter}
                  isRedirect={props.isRedirect}
                  redirectingCompanyName={props.redirectingCompanyName}
                  type={props.type}
                  activeDateRange={props.activeDateRange}
                />
              ) : (
                <></>
              )}
            </span>
          </div>
          <div className="tab-content" id="nav-tabContent">
            {showTabDataHandler()}
          </div>
        </div>
      )}
    </div>
  );
};

export default RightPanel;
